import { memo } from 'react';
import ActionButton from '@molecules/RowActionButton/ActionButton';
import { IActionService } from '@services/actions/IActionService';
import { IBaseAction } from '@models/actions/IBaseAction';
import type { ActionDiagnosticReference } from '@/context/DocumentSupportDiagnosticsContext';
import { DataGridRow } from '../dataGridSchema';

export interface IRowActionsCellProps {
    row: DataGridRow;
    service: IActionService<IBaseAction>;
    onModifyData: () => void;
    /** Диагностическая identity действий списка со своим источником (карта маршрута). */
    getDiagnosticReference?: (action: IBaseAction) => ActionDiagnosticReference;
}

/**
 * Кнопка действий строки. Мемоизирована: меню действий — заметное дерево на
 * каждую строку, а от прокрутки оно не зависит.
 */
const RowActionsCell = memo(({ row, service, onModifyData, getDiagnosticReference }: IRowActionsCellProps) => (
    <ActionButton
        objId={row.key}
        service={service}
        objData={row}
        onModifyData={onModifyData}
        getDiagnosticReference={getDiagnosticReference}
    />
));
RowActionsCell.displayName = 'RowActionsCell';

export default RowActionsCell;
